export const gitVersion = 'main-1.0.13-525-g63c2fb1e';
